import $ from "jquery";
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import jss from 'jss'
import preset from 'jss-preset-default'
import OtherDonate from './components/otherDonate';
import DonateRecent from './components/donateRecent';
import DonateColumns from './components/donateColumns';
import {generateVectorPosition} from 'Client/utils/vector-position';
import {setPaddingSection} from 'Client/utils/padding-section'
import "slick-carousel";

class WidgetHandlerOtherDonate extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				app: '.ecf-way-donate',
				donate_recently: '.col-quote-content .quote-content-list',
				col_donate: '.col-donate-recent-content .content',
				img: ".ecf-donate-bg .list-img-position .img-position-item",
				padding: '#other-way-donate',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings( 'selectors' );
		return {
			$app: this.$element.find( selectors.app ),
			$donate_recently : this.$element.find( selectors.donate_recently ),
			$col_donate: this.$element.find( selectors.col_donate),
			$img: this.$element.find(selectors.img),
			$padding: this.$element.find( selectors.padding ),
		};
	}
	bindEvents() {
		let data = JSON.parse(atob(this.elements.$app[0].getAttribute('data')));
		let img = this.elements.$img;
		let $this = this;
		let donateQuoteContainer = $(this.elements.$donate_recently[0]);
		let dataDonate;
		const THIS = this;
        const ELEMENT = this.elements.$padding[0];
        if(ELEMENT) {
            let dataPadding = ELEMENT.getAttribute('data-padding');
            let dataResponsive = ELEMENT.getAttribute('data-responsive')
            let obj_pd = JSON.parse(atob(dataPadding))
            let obj_responsive = JSON.parse(atob(dataResponsive))
            setPaddingSection(obj_pd, obj_responsive, ELEMENT);
        }
		if(donateQuoteContainer){
			donateQuoteContainer.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				focusOnSelect: true,
				nextArrow:
				  '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next">Next</button>',
				prevArrow:
				  '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev">Previous</button>',
			  });
		}
		img.each(function(index, element){
			let obj = JSON.parse(element.getAttribute('att-position-img'));
			let responsive = JSON.parse(atob(element.getAttribute('att-responsive')))
			generateVectorPosition(obj,responsive,element);
		});

		// let dataDonateCol = JSON.parse(atob(this.elements.$col_donate[0].getAttribute('data-json-col')));
		ReactDOM.render(<App data={data} />, this.elements.$app[0]);

		fetch('https://donation.ehcommunityfund.org.sg/api/donors',{
			method: 'GET',
			cache: 'no-cache',
		})
		.then(res=>res.json())
		.then(data =>{
			ReactDOM.render(<Columns_Donate data={data} />, this.elements.$col_donate[0]);
		})
	}
}

jQuery( window ).on( 'elementor/frontend/init', () => {
	const addHandler = ( $element ) => {
		elementorFrontend.elementsHandler.addHandler( WidgetHandlerOtherDonate, {
			$element,
		} );
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/efc_way_donate.default', addHandler );
} );

class App extends React.Component {
	constructor(props){
		super(props);
		let data = props;
		this.state = {
			data: data
		}
	}
	render() {
		let {data} = this.state;
        let {other_donate} = data.data;
		return (
			<div className="ecf-form-donate__container ecf-section" >
				<OtherDonate data={other_donate} />
            </div>
		)
	}
}

// class Donate_Recently extends React.Component {
// 	constructor(props){
// 		super(props);
// 		let data = props;
// 		this.state = {
// 			data: data
// 		}
		
// 	}
// 	render() {
// 		let {data} = this.state;
		
//         let {quote_donate} = data.data.quote_donate_content;
// 		return (
// 			<div className="quote-content" >
// 				<DonateRecent data={data.data.quote_donate_content} />
//             </div>
// 		)
// 	}
// }

class Columns_Donate extends React.Component {
	constructor(props){
		super(props);
		let data = props;
		this.state = {
			data: data
		}
	}
	render() {
		let {data} = this.state;
		return (
			<div className="content__container pt-4" >
				<DonateColumns data={data} />
            </div>
		)
	}
}
